import styled from 'styled-components';
import { FlexContainer } from '@taxdown/piccolo-web';
import { pxToRem } from 'Styles/utils/utils';
import { DESKTOP_WIDTH, HEADER_HEIGHT, MOBILE_WIDTH, TABLET_WIDTH } from 'Styles/variables/sizes';

export const CloseButton = styled.button`
  cursor: pointer;
  position: absolute;
  right: 15px;
  top: 15px;
  svg {
    width: 16px;
    height: 16px;
  }
`;
export const ModalContainer = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 99;
  background: ${({ theme: { colors } }) => colors.darken};
  display: flex;
  align-items: center;
  margin-top: ${HEADER_HEIGHT};
  justify-content: center;
  @media screen and (max-width: ${DESKTOP_WIDTH}) {
    width: 100%;
    margin-right: 0px;
  }
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    min-width: 100%;
    max-width: 100%;
  }
`;

export const ModalContent = styled(FlexContainer)`
  position: relative;
  background-color: ${({ theme: { colors } }) => colors.white};
  border-radius: 14px;
  min-width: 450px;
  min-height: 450px;
  overflow-y: auto;
  overflow-x: hidden;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    overflow-y: auto;
    overflow-x: hidden;
  }
`;

export const Container = styled(FlexContainer)`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${({ theme: { system } }) => system.background.fds_sys_color_background_gradient_B};
  height: 100%;
`;

export const ItemList = styled.li`
  display: flex;
  align-items: center;
  padding: 0px;
  width: 100%;
  height: ${pxToRem(20)};
  margin-bottom: ${pxToRem(15)};
`;

export const ItemIcon = styled.div`
  display: flex;
  padding: ${pxToRem(10)};
`;

export const DescriptionBenefitsContainer = styled(FlexContainer)`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  width: ${pxToRem(400)};
  margin-top: ${pxToRem(20)};
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
  }
`;

export const ListContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  max-width: 400px;
  svg {
    margin-top: ${({ theme: { spacing } }) => spacing.spacing_08};
  }
`;

export const CardContainer = styled(FlexContainer)`
  @media screen and (max-width: ${TABLET_WIDTH}) {
    flex-wrap: wrap;
    flex-direction: column;
    margin: 20px;
  }
`;

export const CTA = styled(FlexContainer)`
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    display: flex;
    position: sticky;
    z-index: 97;
    bottom: 0;
    width: 100%;
    margin-top: ${({ theme: { reference } }) => reference.dimension_16};
    background-color: ${({ theme }) => theme.system.background.fds_sys_color_blur_M};
    backdrop-filter: ${({ theme }) =>
      `blur(${theme.components.buttons.fds_c_sticky_background_blur})`};
    padding: ${({ theme: { reference } }) => reference.dimension_16};
    border-top: ${({ theme: { system } }) =>
      `${system.fds_sys_borderwidth_S} solid ${system.border.fds_sys_color_border_primary}`};
  }
`;
